import { router } from '@inertiajs/react'
import { Sparkles } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/Card'
import { Switch } from '@/components/ui/Switch'
import { useRouteParams } from '@/hooks/useRoutes'

interface AiSuggestionsToggleProps {
  enabled: boolean
}

/**
 * The only AI control surfaced to workspace admins: turn the AI-drafted chip
 * on/off. Provider, model, monthly spend cap, and cost dashboards live under
 * god-mode (super-admin / billing).
 */
export function AiSuggestionsToggle({ enabled }: AiSuggestionsToggleProps) {
  const { withAccount } = useRouteParams()

  const toggle = (next: boolean) => {
    router.patch(`/${withAccount().account_id}/shortcuts/ai_settings`,
      { suggestions_enabled: next },
      { preserveScroll: true }
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Sparkles className="size-4 text-primary" /> AI-drafted suggestions
        </CardTitle>
        <CardDescription>
          When on, banshee drafts a custom reply chip in the composer based on the visitor's question and your canned answers.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex items-center justify-between">
        <span className="text-sm">{enabled ? 'On' : 'Off'}</span>
        <Switch checked={enabled} onCheckedChange={toggle} className="cursor-pointer" />
      </CardContent>
    </Card>
  )
}
